import { FC } from 'react';

import { Box, Divider, Grid, Stack } from '@mui/material';

import { useSidebarWidth } from '~components/hooks/useSidebarWidth';
import { black } from '~components/theme/styles/colors';

import { useAccountDial } from '../provider';

import { AccountDialAnnouncementsBanner } from './announcementsBanner';
import { AccountDialBridges } from './bridges';
import { AccountDialConnectionButtons } from './connectionButtons';
import { AccountDialCurrentNetwork } from './currentNetwork';
import { AccountDialOverviewFooter } from './footer';
import { AccountDialSystemStats } from './systemStats';
import { AccountDialTransactions } from './transactions';

export const AccountDialOverview: FC<{ show: boolean }> = ({ show }) => {
  const sidebarWidth = useSidebarWidth();
  const { isFullscreen } = useAccountDial();

  return (
    <Box
      sx={{
        zIndex: 5,
        position: 'fixed',
        backdropFilter: 'blur(10px)',
        height: '100vh',
        opacity: show ? 1 : 0,
        display: show ? undefined : 'none',
        pointerEvents: show ? 'all' : 'none',
        transition: 'opacity 0.25s ease-in, width 0.15s linear, left 0.15s linear',
        overflowY: 'auto',
        top: 0,
        background: black['65%'],
      }}
      width={isFullscreen ? '100%' : { xs: '100%', md: `calc(100% - ${sidebarWidth}px)` }}
      left={isFullscreen ? 0 : { xs: 0, md: `${sidebarWidth}px` }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '0 64px',
          width: '100%',
          background: 'url(/v2/backgrounds/blobs_bg.svg)',
          backgroundSize: 'cover',
        }}
      >
        <Grid item xs={12} mb={4}>
          <Stack
            direction={{ md: 'row' }}
            pt="48px"
            sx={{
              gap: '16px',
              width: `calc(100% - 64px)`,
            }}
          >
            <AccountDialAnnouncementsBanner />
            <AccountDialCurrentNetwork />
            <AccountDialConnectionButtons onDisconnect={() => {}} />
          </Stack>
        </Grid>
        <Grid container justifyContent={{ xs: 'center', sm: 'start' }} spacing={4}>
          <Grid item md={4}>
            <Stack direction={'column'} spacing={4}>
              <AccountDialSystemStats hideSocials forceOpen />
              <AccountDialBridges forceOpen />
            </Stack>
          </Grid>
          <Grid item md={4}>
            <AccountDialTransactions forceOpen />
          </Grid>
        </Grid>
        <Divider sx={{ margin: '48px 0' }} />
        <AccountDialOverviewFooter />
      </Box>
    </Box>
  );
};
